function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "10.583mm",
    height: "10.583mm",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "BG"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ebene_11",
    "data-name": "Ebene_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0,7.105h30v15.789H0V7.105Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,22.389V7.105h30v3.347L0,22.389Z",
    style: {
      fill: "#dd7500"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,22.137V7.105h30v.253L0,22.137ZM0,22.642v.253h30v-9.347L0,22.642Z",
    style: {
      fill: "#003893"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.765,7.976l.202,3.361.705-1.852-.315,1.956,1.161-1.606-.811,1.808,1.537-1.251-1.251,1.537,1.808-.81-1.606,1.16,1.957-.315-1.852.706,3.361.202-3.361.202,1.852.705-1.957-.315,1.606,1.161-1.808-.811,1.251,1.537-1.537-1.251.811,1.808-1.161-1.608.315,1.957-.705-1.852-.202,3.361-.202-3.361-.705,1.852.315-1.957-1.16,1.606.81-1.808-1.537,1.251,1.251-1.537-1.808.811,1.606-1.161-1.956.315,1.852-.705-3.361-.202,3.361-.202-1.852-.706,1.956.315-1.606-1.16,1.808.81-1.251-1.537,1.537,1.251-.81-1.808,1.16,1.606-.315-1.956.705,1.852.202-3.359Z",
    style: {
      fill: "#fff"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMh);
export default __webpack_public_path__ + "static/media/MH.6eff89dfcb548c3fa00dd69f796ede98.svg";
export { ForwardRef as ReactComponent };